/**
 * AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
 *
 * This file is generated by the theme generator.
 * To modify typography tokens, edit: scripts/theme-generator/config.ts
 * Then run: pnpm generate:themes
 */

/**
 * Atoms typography utility names — the `{family}-{size}` part of each
 * `text-*` utility (e.g. `text-display-lg`). Source of truth:
 * `THEME_CONFIG.typography` in scripts/theme-generator/config.ts.
 */
export const ATOMS_TYPOGRAPHY_CLASSES = [
  'display-lg',
  'display-md',
  'display-sm',
  'display-xs',
  'header-lg',
  'header-md',
  'header-sm',
  'subheader-lg',
  'subheader-md',
  'subheader-sm',
  'subheader-xs',
  'body-xl',
  'body-lg',
  'body-md',
  'body-sm',
  'body-xs',
  'label-xl',
  'label-lg',
  'label-md',
  'label-sm',
  'label-xs',
] as const;

export type AtomsTypographyClass = (typeof ATOMS_TYPOGRAPHY_CLASSES)[number];

export type AtomsTypographyToken = {
  name: string;
  className: string;
  family: string;
  size: string;
  fontSize: string | undefined;
  lineHeight: string | undefined;
  fontWeight: string | undefined;
  letterSpacing: string | undefined;
};

export const ATOMS_TYPOGRAPHY_TOKENS: AtomsTypographyToken[] = [
  {
    name: 'display-lg',
    className: 'text-display-lg',
    family: 'display',
    size: 'lg',
    fontSize: '117px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.036em',
  },
  {
    name: 'display-md',
    className: 'text-display-md',
    family: 'display',
    size: 'md',
    fontSize: '92px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.034em',
  },
  {
    name: 'display-sm',
    className: 'text-display-sm',
    family: 'display',
    size: 'sm',
    fontSize: '65px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.034em',
  },
  {
    name: 'display-xs',
    className: 'text-display-xs',
    family: 'display',
    size: 'xs',
    fontSize: '58px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.034em',
  },
  {
    name: 'header-lg',
    className: 'text-header-lg',
    family: 'header',
    size: 'lg',
    fontSize: '45px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.03em',
  },
  {
    name: 'header-md',
    className: 'text-header-md',
    family: 'header',
    size: 'md',
    fontSize: '40px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.03em',
  },
  {
    name: 'header-sm',
    className: 'text-header-sm',
    family: 'header',
    size: 'sm',
    fontSize: '36px',
    lineHeight: '1',
    fontWeight: '500',
    letterSpacing: '-0.03em',
  },
  {
    name: 'subheader-lg',
    className: 'text-subheader-lg',
    family: 'subheader',
    size: 'lg',
    fontSize: '32px',
    lineHeight: '1.1',
    fontWeight: '500',
    letterSpacing: '-0.028em',
  },
  {
    name: 'subheader-md',
    className: 'text-subheader-md',
    family: 'subheader',
    size: 'md',
    fontSize: '28px',
    lineHeight: '1.1',
    fontWeight: '500',
    letterSpacing: '-0.028em',
  },
  {
    name: 'subheader-sm',
    className: 'text-subheader-sm',
    family: 'subheader',
    size: 'sm',
    fontSize: '25px',
    lineHeight: '1.12',
    fontWeight: '500',
    letterSpacing: '-0.028em',
  },
  {
    name: 'subheader-xs',
    className: 'text-subheader-xs',
    family: 'subheader',
    size: 'xs',
    fontSize: '22px',
    lineHeight: '1.14',
    fontWeight: '500',
    letterSpacing: '-0.024em',
  },
  {
    name: 'body-xl',
    className: 'text-body-xl',
    family: 'body',
    size: 'xl',
    fontSize: '20px',
    lineHeight: '1.2',
    fontWeight: '400',
    letterSpacing: '-0.024em',
  },
  {
    name: 'body-lg',
    className: 'text-body-lg',
    family: 'body',
    size: 'lg',
    fontSize: '18px',
    lineHeight: '1.45',
    fontWeight: '400',
    letterSpacing: '-0.024em',
  },
  {
    name: 'body-md',
    className: 'text-body-md',
    family: 'body',
    size: 'md',
    fontSize: '16px',
    lineHeight: '1.5',
    fontWeight: '400',
    letterSpacing: '-0.014em',
  },
  {
    name: 'body-sm',
    className: 'text-body-sm',
    family: 'body',
    size: 'sm',
    fontSize: '14px',
    lineHeight: '1.4',
    fontWeight: '400',
    letterSpacing: '-0.014em',
  },
  {
    name: 'body-xs',
    className: 'text-body-xs',
    family: 'body',
    size: 'xs',
    fontSize: '12px',
    lineHeight: '1.4',
    fontWeight: '400',
    letterSpacing: '-0.014em',
  },
  {
    name: 'label-xl',
    className: 'text-label-xl',
    family: 'label',
    size: 'xl',
    fontSize: '20px',
    lineHeight: '1.2',
    fontWeight: '500',
    letterSpacing: '-0.024em',
  },
  {
    name: 'label-lg',
    className: 'text-label-lg',
    family: 'label',
    size: 'lg',
    fontSize: '18px',
    lineHeight: '1.2',
    fontWeight: '500',
    letterSpacing: '-0.024em',
  },
  {
    name: 'label-md',
    className: 'text-label-md',
    family: 'label',
    size: 'md',
    fontSize: '16px',
    lineHeight: '1.25',
    fontWeight: '500',
    letterSpacing: '-0.014em',
  },
  {
    name: 'label-sm',
    className: 'text-label-sm',
    family: 'label',
    size: 'sm',
    fontSize: '14px',
    lineHeight: '1.25',
    fontWeight: '500',
    letterSpacing: '-0.014em',
  },
  {
    name: 'label-xs',
    className: 'text-label-xs',
    family: 'label',
    size: 'xs',
    fontSize: '12px',
    lineHeight: '1.25',
    fontWeight: '500',
    letterSpacing: '-0.014em',
  },
];
